module.exports = __webpack_public_path__ + "img/ico_ns_academy.c018430b.svg";